import { render, staticRenderFns } from "./MicroViewInternacao.vue?vue&type=template&id=4b3ebf4e&"
import script from "./MicroViewInternacao.vue?vue&type=script&lang=js&"
export * from "./MicroViewInternacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports